<div class="clients-table-container">
  <app-data-table
    [value]="clients()"
    [loading]="loading()"
    [totalRecords]="totalRecords()"
    [rows]="rows()"
    [currentPage]="currentPage()"
    [columns]="columns()"
    [bodyTemplate]="bodyTpl"
    [globalFilterFields]="['name']"
    (onLazyLoad)="onLazyLoad()($event)"
  >
    <ng-template #bodyTpl let-client>
      <tr>
        <td data-label="Nazwa">{{ client.name }}</td>
        <td data-label="Email">{{ !client.email ? '-' : client.email }}</td>
        <td data-label="Telefon">{{ !client.phone ? '-' : client.phone }}</td>
        @if (isOwner()) {
          <td data-label="Akcje">
            <div class="flex flex-row items-center justify-end gap-2">
              <p-button
                class="note-button"
                icon="pi pi-pen-to-square"
                tooltipPosition="top"
                pTooltip="{{ client.note || 'Brak notatki' }}"
                severity="info"
                rounded
                [size]="'small'"
                [text]="true"
              />
              <p-button
                icon="pi pi-pencil"
                (onClick)="requestEdit(client)"
                severity="warn"
                rounded
                [size]="'small'"
                [text]="true"
              />
              <p-button
                icon="pi pi-trash"
                (onClick)="requestDelete(client)"
                severity="danger"
                rounded
                [size]="'small'"
                [text]="true"
              />
            </div>
          </td>
        }
      </tr>
    </ng-template>
  </app-data-table>
</div>
